<app-header></app-header>
<div id="logoutContainer"> 
                <h4>Log Out</h4> 
                <h5>You have been logged out of this application.</h5> 
                <p>To completely log out of Single Sign On, please close your browser.</p> 
        </div>

